import React from 'react';

const LoadingSpinner: React.FC = () => (
  <div className="flex items-center justify-center py-20">
    <div className="w-8 h-8 border-2 border-[#FF9C15] border-t-transparent rounded-full animate-spin" />
  </div>
);

export default LoadingSpinner;
